/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryProductsEditDialog extends Common.GridEditorDialog<EnquiryProductsRow> {
        protected getFormKey() { return EnquiryProductsForm.formKey; }
        protected getLocalTextPrefix() { return EnquiryProductsRow.localTextPrefix; }

        protected form: EnquiryProductsForm;
        public maxMark: number;
        constructor() {
            super();
            //
            this.form = new EnquiryProductsForm(this.idPrefix);

            this.form.ProductId.changeSelect2(e => {
                try {
                    debugger;
                    var strudentId = this.form.ProductId.value;
                    //var ProductId = this.form.ProductId.value;
                    if (parseInt(strudentId) == 0) {
                        //this.setProductDetails({});
                        return;
                    }
                    else {
                        debugger;

                        var productName = Q.first(Products.ProductsRow.getLookup().items, x => x.Id == Number(strudentId)).ProductName;
                        this.form.ProductProductName.value = productName.toString();
                    }
                } catch (e) {
                    alert(e.message);
                    debugger;
                }
            });
            
           
        }
        loadEntity(entity: EnquiryRow) {
            //debugger;
            super.loadEntity(entity);
        }
    }
}